import { Injectable } from "@angular/core";
import { SubscriptionPlanService as SubscriptionPlanServiceBase } from "clearline-api";

@Injectable({
  providedIn: "root"
})
/** @deprecated Use import from `clearline-api` */
export class SubscriptionPlanService extends SubscriptionPlanServiceBase {}
